import { actionTypesOperations as actionTypes } from "../constants/actionTypesOperations";
import { operationsState } from "../state/operations";

const operationsReducer = (state = operationsState, action: any) => {
  switch (action.type) {
    case actionTypes.ListOfOperations:
      return {
        ...state,
        operationsList: action.payload,
        isOperationsListLoaded: true,
      };
    case actionTypes.ListOfOperationUsers:
      return {
        ...state,
        operationUsersList: action.payload,
        isOperationUsersLoaded: true,
      };
    case actionTypes.OperationAttachmentsList:
      return {
        ...state,
        operationAttachmentsList: action.payload,
        isAttachmentsLoaded: true,
      };
    case actionTypes.IsOperationsTableRefreshed:
      return {
        ...state,
        isOperationsListLoaded: action.payload,
      };
    case actionTypes.SelectedOperation:
      return {
        ...state,
        selectedOperation: action.payload,
      };
    case actionTypes.FilterOperations:
      return {
        ...state,
        operationsList: action.payload,
        isOperationsListLoaded: true,
      };
    case actionTypes.SearchOperations:
      return {
        ...state,
        isOperationsListLoaded: true,
        operationsList: action.payload,
      };
    case actionTypes.OperationHistoryList:
      return {
        ...state,
        operationAuditConfig: {
          ...state.operationAuditConfig,
          isOperationHistoryLoaded: true,
          operationHistoryList: action.payload.data,
          totalCount:
            action.payload.pagination.totalCount ??
            state.operationAuditConfig.totalCount,
          totalPages:
            action.payload.pagination.totalPages ??
            state.operationAuditConfig.totalPages,
          page:
            action.payload.pagination.page ?? state.operationAuditConfig.page,
          pageSize:
            action.payload.pagination.pageSize ??
            state.operationAuditConfig.pageSize,
        },
      };
    case actionTypes.UpdateOperationAuditSort:
      return {
        ...state,
        operationAuditConfig: {
          ...state.operationAuditConfig,
          sort: action.payload,
        },
      };

    case actionTypes.UpdateOperationAuditPage:
      return {
        ...state,
        operationAuditConfig: {
          ...state.operationAuditConfig,
          page: action.payload,
        },
      };

    case actionTypes.UpdateOperationAuditPageSize:
      return {
        ...state,
        operationAuditConfig: {
          ...state.operationAuditConfig,
          pageSize: action.payload,
        },
      };
    default:
      return state;
  }
};

export default operationsReducer;
